// src/pages/ProcessifydHome.jsx
import React, { useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../redux/actions/authActions";

const ProcessifydHome = () => {
  const authState = useSelector((state) => state.authReducer || {});
  const isLoggedIn = authState?.isLoggedIn || false;
  const userName = authState?.user?.name || "User";

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const buttons = [
    { label: "Dashboard", emoji: "📊", link: "/processifyd-dashboard" },
    { label: "Clients", emoji: "🏢", link: "/processifyd-clients" },
    { label: "Processes", emoji: "⚙️", link: "/processifyd-processes" },
    { label: "States", emoji: "🔘", link: "/processifyd-states" },
    { label: "State Transitions", emoji: "🔄", link: "/processifyd-statetransitions" },
    { label: "Variables", emoji: "🔣", link: "/processifyd-variables" },  
    { label: "Groups", emoji: "👥", link: "/processifyd-groups" },
    { label: "RACI Persons", emoji: "👥", link: "/processifyd-racipersons" },
    { label: "RACI", emoji: "🧩", link: "/processifyd-raci" },
    { label: "Users", emoji: "👤", link: "/processifyd-users" },
    { label: "Mappings", emoji: "🗺️", link: "/processifyd-mappings" },
    { label: "One-View", emoji: "🧾", link: "/processifyd-oneview" },
    { label: "Approvals", emoji: "✅", link: "" },
    { label: "Help", emoji: "❓", link: "/processifyd-helptexts" },
    { label: "Scripts", emoji: "📜", link: "/processifyd-scripts" },
    { label: "Communications", emoji: "💬", link: "" },
    { label: "References", emoji: "📎", link: "/processifyd-references" },
    { label: "Errors", emoji: "⚠️", link: "" },
    { label: "Logs", emoji: "📚", link: "" },
    { label: "IIOT & Telemetry", emoji: "📡", link: "" }, 
    { label: "Training & Workshop", emoji: "🎓", link: "/enroll/workshop" },
    { label: "BPM Immersive Books", emoji: "🗓️", link: "" },    
    { label: "Immersive Booksshelf", emoji: "📖", link: "/bookshelf" }, 
    { label: "BPM Skill Certification", emoji: "📜", link: "" },            
  ];

  return (
    <div className="min-h-screen flex flex-col bg-black text-gray-100 font-sans">
      <header className="sticky top-0 z-50 bg-black border-b border-blue-400 px-4 py-3 flex items-center justify-between">
        <div className="flex flex-col">
          <div className="text-lg lg:text-xl font-bold text-yellow-200">Processifyd</div>
          <div className="text-[11px] text-gray-200">Process Center!</div>
        </div>

        <div className="hidden md:flex items-center gap-3">
          {isLoggedIn ? (
            <>
              <div className="text-xs lg:text-sm text-teal-300">{userName}</div>
              <button
                onClick={handleLogout}
                className="w-8 mt-2 px-2 py-1 rounded-md bg-red-600 hover:bg-red-700 transition"
                title="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="w-8 px-2 py-1 rounded-full border border-gray-700 text-sm text-gray-200 hover:bg-gray-800"
              >
                🔐 
              </button>
            </>
          )}
        </div>
        <button
          onClick={() => setIsMobileMenuOpen((s) => !s)}
          className="md:hidden w-8 h-8 flex items-center justify-center text-2xl text-teal-300"
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? "×" : "☰"}
        </button>
      </header>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-900 border-b border-gray-800 px-4 py-3">
          {isLoggedIn ? (
            <div className="flex flex-col items-center gap-3">
              <div className="text-teal-300 text-xs lg:text-sm font-medium">{userName}</div>
                <div className="flex gap-3">
                  <button
                    onClick={handleLogout}
                    className="p-2 rounded-md bg-red-600 hover:bg-red-700"
                  >
                    ⏻
                  </button>
                </div>
            </div>
          ) : (
            <div className="flex justify-center gap-6">
              <Link to="/login" className="text-teal-300">🔐</Link>
            </div>
          )}
        </div>
      )}

      <div className="min-h-[75vh] mt-2 mb-1 px-3 py-2 border-b-2 border-gray-500">
        <div className="grid grid-cols-3 lg:grid-cols-6 gap-2  border-gray-600 place-items-center">
          {buttons.map((btn) => (
            <button
              key={btn.label}
              onClick={() => navigate(btn.link)}
              className="flex flex-col items-center justify-center w-full px-1 py-1 rounded-md text-xs lg:text-sm font-medium bg-gray-700 text-yellow-200"
            >
              <span className="text-lg">{btn.emoji}</span>
              <span className="mt-1 text-center">{btn.label}</span>
            </button>
          ))}
        </div>
      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-4">
        <div className="mx-auto px-3 flex flex-col lg:flex-row items-center justify-between gap-3">
          <div className="text-sm text-yellow-200">© 2026 Think5Whys Global DeepTech Solutions.</div>
          <div className="flex flex-wrap gap-4 text-sm">
            <Link to="/about-us" className="hover:text-teal-300">About</Link>
            <Link to="/privacy-policy" className="hover:text-teal-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="hover:text-teal-300">Terms of Use</Link>
            <Link to="/contact-us" className="hover:text-teal-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ProcessifydHome;
